import React, { useState, useRef, useEffect } from "react";
import "./Multiselect.css";
import { useTranslation } from "react-i18next";
const Multiselect = ({
  onSuppliers,
  options,
  type,
  selectedOptions,
  setSelectedOptions,
}) => {
  const { t } = useTranslation();
  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    onSuppliers(selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const toggleOption = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
    setIsOpen(!isOpen);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const toggleSelectAll = () => {
    if (selectedOptions.length === options.length) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions([...options]);
    }
    setIsOpen(!isOpen);
  };

  const removeOption = (option) => {
    setSelectedOptions(selectedOptions.filter((item) => item !== option));
  };

  return (
    <div className="multi-select-dropdown" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {/* <label>Select Options:</label> */}
        <div className="allSet">
          <span>{`${t("select")} ${type}`}</span>
          {/* {selectedOptions.length === 0 ? <span>Select {type}</span> :
            [new Array(new Set(selectedOptions))].map(option => (
              <span key={option} className="selected-option">
                {selectedOptions+`${([new Array(new Set(selectedOptions))].length-1)?',':''}`}
                <button className="remove-button" onClick={() => removeOption(option)}>Remove</button>
              </span>
            ))} */}
        </div>
      </div>
      {isOpen && (
        <div className="options-container">
          <div>
            <input
              type="checkbox"
              checked={selectedOptions.length === options.length}
              onChange={toggleSelectAll}
            />
            <label>All {type}</label>
          </div>
          {options.map((option) => (
            <div key={option}>
              <input
                type="checkbox"
                value={option}
                checked={selectedOptions.includes(option)}
                onChange={() => toggleOption(option)}
              />
              <label>{option}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Multiselect;
